<form [formGroup]="form" (submit)="save()">
  <h2 mat-dialog-title style="text-transform: capitalize">
    <mat-icon class="fa"
      [class.fa-users]="editableParty"
      [class.fa-calculator]="!editableParty"
    ></mat-icon>
    Change {{party}} {{editableParty ? '' : ' Formula'}}
  </h2>
  <div mat-dialog-content [class.tc-editable-party]="!!editableParty">
    @if (editableParty) {
      <tc-select-search placeholder="Deals {{party}}"
        [ctrl]="form.controls.account"
        [items]="accounts$ | async" bindValue="account" bindLabel="name"
        (change)="onAccountChange($event)"
      ></tc-select-search>
      <mat-radio-group [formControl]="form.controls.dontChangePrice" (change)="onDontChangePriceChange($event)">
        <mat-radio-button value="dont">Do not change price</mat-radio-button>
      </mat-radio-group>
    }

    <mat-accordion displayMode="flat" multi>
      @for (pl of productLines; track $index; let productIndex = $index) {
        @if (pl.show) {
        <mat-expansion-panel hideToggle [expanded]="pl.form.controls.checked.value" disabled class="mat-elevation-z0">
          @if (editableParty) {
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-checkbox [formControl]="pl.form.controls.checked" (change)="onCheckedChange($event)">{{pl.title$ | async}}</mat-checkbox>
            </mat-panel-title>
          </mat-expansion-panel-header>
          }
          <!-- WA-22777: USDA proposal for this line (live preview of the formula on screen once the deal is saved) -->
          @if (pl.usda; as u) {
            @let pv = u.preview$ | async;
            @if (pv ? pv.visible : u.savedUsda) {
              <tc-usda-proposal-panel
                [entry]="u.entry" [evaluated]="u.evaluated" noDealText="No USDA proposal yet – save the deal first."
                [preview]="pv" [currency]="u.currency" [unit]="u.unit" [formula]="u.currentFormula$ | async"
                (useProposedPrice)="useProposedPrice(pl)"
              ></tc-usda-proposal-panel>
            }
          }
          <mat-radio-group [formControl]="pl.form.controls.priceType">
            <mat-radio-button value="flat" #flat>
              @if (flat.checked) {
                <mat-form-field>
                  <mat-label>Flat Price{{currency ? ' (' + currency + ')' : ''}}</mat-label>
                  <input matInput [formControl]="pl.form.controls.price" type="number" autocomplete="off" step="0.0001" min="0" >
                </mat-form-field>
              } @else {
                Set Flat price
              }
            </mat-radio-button>
            <mat-radio-button value="formula" #formula>
              @if (formula.checked) {
                <div class="formula-form">
                  @if ((pl.usdaProductName$ | async)?.applies) {
                    <tc-select-search placeholder="Product Name"
                        [ctrl]="pl.form.controls.productName"
                        [items]="(pl.usdaProductName$ | async)?.options" bindValue="value" bindLabel="value"
                        [searchFn]="searchUsdaProductNameOption"
                        >
                      <ng-template tcSelectSearchOption let-item="item" let-text="text">
                        <span [class.tc-usda-not-recently-priced]="item?.notRecentlyPriced">{{ item?.value ?? text }}</span>
                        @if (item?.section) {
                          <small class="text-gray"> &middot; {{ item.section }}</small>
                        }
                      </ng-template>
                    </tc-select-search>
                  } @else {
                    <mat-form-field>
                      <mat-label>Product Name</mat-label>
                      <input matInput [formControl]="pl.form.controls.productName" autocomplete="off">
                    </mat-form-field>
                  }
                  <tc-select-search placeholder="Price Source"
                      [ctrl]="pl.form.controls.priceSource"
                      [items]="pl.priceSourceOptions$ | async" bindValue="value" bindLabel="value"
                      ></tc-select-search>
                  <mat-form-field>
                    <mat-label>Days</mat-label>
                    <input matInput [formControl]="pl.form.controls.days" type="number" autocomplete="off" min="0" step="0.0001">
                  </mat-form-field>
                  <tc-select-search placeholder="Before Date"
                      [ctrl]="pl.form.controls.beforeDate"
                      [items]="paymentTermsDates" bindValue="id" bindLabel="name"
                      ></tc-select-search>
                </div>
                @for (lineForm of pl.linesForm.controls; track lineForm; let lineIndex = $index) {
                  <div class="line-form" [formGroup]="lineForm">
                    <span style="text-align: right; white-space: pre;">- Sheet</span>
                    <mat-slide-toggle [formControl]="lineForm.controls.positive" color="primary"></mat-slide-toggle>
                    <mat-form-field>
                      <mat-label>Price</mat-label>
                      <input matInput autocomplete="off" [formControl]="lineForm.controls.price" type="number" min="0">
                    </mat-form-field>
                    <tc-select-search placeholder="Incoterm"
                        [ctrl]="lineForm.controls.incoterm"
                        [items]="pricingTerms$ | async" bindValue="pricing_terms_id" bindLabel="term"
                        ></tc-select-search>
                    <div>
                      <tc-select-search placeholder="Location"
                        [ctrl]="lineForm.controls.location"
                        [items]="filteredLocations$(productIndex, lineIndex) | async" bindValue="location_id" bindLabel="name"
                      ></tc-select-search>
                      <button mat-button type="button" (click)="toggleLocations(productIndex, lineIndex)">
                        <small>{{ (allVisible$ | async)['' + productIndex + '-' + lineIndex] ? 'Show Party Locations' : 'Show All Locations' }}</small>
                      </button>
                    </div>
                    <mat-form-field>
                      <mat-label>Conditions</mat-label>
                      <input matInput autocomplete="off" [formControl]="lineForm.controls.conditions">
                    </mat-form-field>
                    @if (pl.linesForm.length > 1) {
                      <button type="button" mat-icon-button color="warn" (click)="removeLine(pl, lineIndex)">
                        <mat-icon class="fa fa-minus-circle"></mat-icon>
                      </button>
                    }
                  </div>
                }
                <div class="text-right">
                  <button mat-button type="button" (click)="addNewLine(pl)">
                    <i class="fa fa-plus"></i> ADD FORMULA LINE</button>
                </div>
              } @else {
                Set Formula
              }
            </mat-radio-button>
          </mat-radio-group>
        </mat-expansion-panel>
        }
      }
    </mat-accordion>
  </div>
  <mat-progress-bar [mode]="(inProgress$|async) ? 'indeterminate' : undefined"></mat-progress-bar>
  <div mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close="">Cancel</button>
    <button mat-raised-button type="submit" color="primary">
      <i class="fa fa-fw" aria-hidden="true"
          [class.fa-check]="(inProgress$ | async) !== 'save'"
          [class.fa-spin]="(inProgress$ | async) === 'save'"
          [class.fa-spinner]="(inProgress$ | async) === 'save'"
          ></i>
      Update
    </button>
  </div>
</form>
